/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EngineerStatsDtoDlmBaseResponse } from '../models/engineer-stats-dto-dlm-base-response';
import { WidgetStatsDtodlmBaseResponse } from '../models/widget-stats-dtodlm-base-response';

@Injectable({
  providedIn: 'root',
})
export class DashboardService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiDashboardStatsGet
   */
  static readonly ApiDashboardStatsGetPath = '/api/Dashboard/stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDashboardStatsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardStatsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<WidgetStatsDtodlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DashboardService.ApiDashboardStatsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WidgetStatsDtodlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDashboardStatsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardStatsGet$Plain(params?: {
  }): Observable<WidgetStatsDtodlmBaseResponse> {

    return this.apiDashboardStatsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<WidgetStatsDtodlmBaseResponse>) => r.body as WidgetStatsDtodlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDashboardStatsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardStatsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<WidgetStatsDtodlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DashboardService.ApiDashboardStatsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WidgetStatsDtodlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDashboardStatsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardStatsGet$Json(params?: {
  }): Observable<WidgetStatsDtodlmBaseResponse> {

    return this.apiDashboardStatsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<WidgetStatsDtodlmBaseResponse>) => r.body as WidgetStatsDtodlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiDashboardEngineerStatsGet
   */
  static readonly ApiDashboardEngineerStatsGetPath = '/api/Dashboard/engineer-stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDashboardEngineerStatsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardEngineerStatsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<EngineerStatsDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DashboardService.ApiDashboardEngineerStatsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EngineerStatsDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDashboardEngineerStatsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardEngineerStatsGet$Plain(params?: {
  }): Observable<EngineerStatsDtoDlmBaseResponse> {

    return this.apiDashboardEngineerStatsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<EngineerStatsDtoDlmBaseResponse>) => r.body as EngineerStatsDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDashboardEngineerStatsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardEngineerStatsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<EngineerStatsDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DashboardService.ApiDashboardEngineerStatsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EngineerStatsDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDashboardEngineerStatsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardEngineerStatsGet$Json(params?: {
  }): Observable<EngineerStatsDtoDlmBaseResponse> {

    return this.apiDashboardEngineerStatsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<EngineerStatsDtoDlmBaseResponse>) => r.body as EngineerStatsDtoDlmBaseResponse)
    );
  }

}
